import { apiService } from './api';

export interface TelegramAuthRequest {
  initData: string;
}

export interface AuthResponse {
  accessToken: string;
  user: {
    id: string;
    telegramId: number | null;
    firstName: string;
    username: string | null;
    avatarUrl: string | null;
  };
}

export const authService = {
  authenticate: async (initData: string): Promise<AuthResponse> => {
    // Use /api/auth/telegram - will be proxied by setupProxy.js or handled by Nginx
    // Таймаут: зависшая сеть (частый случай с VPN) должна упасть быстро, чтобы сработал ретрай.
    const response = await apiService.client.post(
      '/api/auth/telegram',
      { initData },
      { timeout: 15000 },
    );
    // apiService interceptor already extracts data from response
    const authResponse = response as unknown as AuthResponse;
    if (authResponse && authResponse.accessToken) {
      apiService.setToken(authResponse.accessToken);
    }
    return authResponse;
  },

  authenticateByUsername: async (
    username: string,
    browserE2eToken: string,
  ): Promise<AuthResponse> => {
    const response = await apiService.client.post('/api/auth/username', {
      username,
      browserE2eToken,
    });
    const authResponse = response as unknown as AuthResponse;
    if (authResponse && authResponse.accessToken) {
      apiService.setToken(authResponse.accessToken);
    }
    return authResponse;
  },

  refresh: async (): Promise<{ accessToken: string }> => {
    const response = await apiService.client.post('/api/auth/refresh');
    // apiService interceptor already extracts data from response
    const refreshResponse = response as unknown as { accessToken: string };
    if (refreshResponse && refreshResponse.accessToken) {
      apiService.setToken(refreshResponse.accessToken);
    }
    return refreshResponse;
  },
};

